export class StreamAudio {
  constructor() {
    this.ctx = null;
    this.gain = null;
    this.next = {};
    this.volume = Number(localStorage.getItem("crank_play_volume") ?? 0.8);
    this.muted = localStorage.getItem("crank_play_muted") === "1";
    this.received = 0;
  }

  unlock() {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return;
    if (!this.ctx) {
      this.ctx = new AC({ latencyHint: "interactive" });
      this.gain = this.ctx.createGain();
      this.gain.connect(this.ctx.destination);
      this.apply();
    }
    if (this.ctx.state === "suspended") this.ctx.resume();
  }

  apply() {
    if (this.gain) this.gain.gain.value = this.muted ? 0 : this.volume;
    localStorage.setItem("crank_play_volume", String(this.volume));
    localStorage.setItem("crank_play_muted", this.muted ? "1" : "0");
  }

  // payload: [ctxId u8][sampleRate u32 LE][Int16 mono PCM]
  push(buf) {
    this.received += 1;
    if (!this.ctx || this.ctx.state !== "running" || buf.byteLength < 7) return;
    const dv = new DataView(buf);
    const id = dv.getUint8(0);
    const rate = dv.getUint32(1, true);
    const n = (buf.byteLength - 5) >> 1;
    if (!n || rate < 8000 || rate > 96000) return;
    const pcm = new Int16Array(buf.slice(5, 5 + n * 2));
    const ab = this.ctx.createBuffer(1, n, rate);
    const ch = ab.getChannelData(0);
    for (let i = 0; i < n; i++) ch[i] = pcm[i] / 32768;
    const src = this.ctx.createBufferSource();
    src.buffer = ab;
    src.connect(this.gain);
    const now = this.ctx.currentTime;
    let t = this.next[id] || 0;
    if (t < now + 0.04 || t > now + 0.6) t = now + 0.08;
    src.start(t);
    this.next[id] = t + ab.duration;
  }

  close() {
    try { this.ctx?.close(); } catch { /* already closed */ }
    this.ctx = null;
  }
}
